/*
* @Author: zhaofy
* @Date: 2018-01-25 22:55:56
 * @Last Modified by: 李志远
 * @Last Modified time: 2021-10-We 10:36:52
* @title: 商品评论
*/
<template>
  <!-- 商品评价、详情、销售记录部分 -->
  <div class="main">
    <div class="tab">
      <span
        v-for="(item, index) of tab"
        :key="index"
        :class="{'active': currTab === index}"
        @click.stop.prevent="cTab(index)"
      >{{item}}</span>
    </div>
    <div class="content-box">
      <!-- 商品详情 -->
      <div
        v-show="currTab === 0"
        class="goods-detail"
      >
        <div
          class="video"
          v-show="goodsVideo"
        >
          <video
            :src="goodsVideo"
            loop
            controls
          ></video>
        </div>
        <div
          class="default"
          v-html="goodsIntros"
        ></div>
      </div>
      <!-- 商品评论 -->
      <div
        v-show="currTab === 1"
        class="comment"
      >
        <div class="grade">
          <span>宝贝与描述相符</span>
          <span><i></i><i></i><i></i><i></i><i></i></span>
          <div
            v-show="isLogin && commentFalg"
            class="shoppl"
          >
            <a
              name="firstAnchor"
              id="firstAnchor"
              style="color: #333;"
              href="javascript:void(0)"
              v-on:click="jump()"
            >我要评论</a>
          </div>
        </div>
        <div
          v-if="comment.total === 0"
          class="not-data"
        >
          <div>暂无评论，抢沙发，赢取更多积分。</div>
          <div>共0条记录</div>
        </div>
        <div v-else>
          <div class="list">
            <ul>
              <li
                v-for="(item,index) of comment.list"
                :key="index"
              >
                <div class="pic">
                  <img :src="item.face"><span>{{item.uname | filter_name}}</span><span>{{item.levelname}}</span>
                </div>
                <div class="right">
                  <div>{{item.content}}</div>
                  <div><span>评分：<b
                        v-if="item.grade=='1'"
                        style="font-weight: normal;"
                      >差评</b><b
                        v-if="item.grade=='2'"
                        style="font-weight: normal;"
                      >中评</b><b
                        v-if="item.grade=='3'"
                        style="font-weight: normal;"
                      >好评</b></span><span>{{unixToDate(item.dateline)}}</span>
                  </div>
                  <div
                    class="suolue"
                    v-if="item.videoPath"
                  >
                    <video
                      :src="item.videoPath"
                      controls
                      class='fl'
                      width="150"
                      height='150'
                    ></video>
                  </div>
                  <viewer
                    class="suolue"
                    :images="toArr(item.img)"
                  >
                    <img
                      v-for="(src,index) in toArr(item.img)"
                      :src="src"
                      :key="index"
                      width="150"
                      height='150'
                    >
                  </viewer>
                  <viewer
                    class="suolue"
                    :images="toArr(item.imagePath)"
                  >
                    <img
                      v-for="(src,index) in toArr(item.imagePath)"
                      :src="src"
                      :key="index"
                      width="150"
                      height='150'
                    >
                  </viewer>
                  <div v-if="item.reply !== null">
                    <div class="top"></div>
                    <div class="reply">
                      <h3>开心云商客服：</h3>
                      <p>{{item.reply}}</p>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </li>
            </ul>
          </div>
          <paging
            :getList="getCommentList"
            :total="comment.total"
            :pages="comment.pages"
            :no.sync="page.no1"
          >
          </paging>
        </div>
        <div
          id="discuss_form_wrapper"
          v-show="isLogin && commentFalg"
        >
          <form
            action="#"
            method="post"
            id="ivu-form"
            style="padding: 0px"
          >
            <div class="discuss_issue">
              <div class="di_left">
                <h2>
                  <b>描述相符：</b>
                  <div class="grade">
                    <Rate v-model="desccredit"></Rate>
                  </div>
                  <span class="value_wrapper">
                    您的评分：
                    <span style="font-weight: bold; font-size: 14px; color: #a90000;">{{desccredit}}</span>分
                  </span>
                </h2>

                <h2>
                  <b>服务态度：</b>
                  <div class="grade">
                    <Rate v-model="servicecredit"></Rate>
                  </div>
                  <span class="value_wrapper">
                    您的评分：
                    <span style="font-weight: bold; font-size: 14px; color: #a90000;">{{servicecredit}}</span>分
                  </span>
                </h2>

                <h2>
                  <b>发货速度：</b>
                  <div class="grade">
                    <Rate v-model="deliverycredit"></Rate>
                  </div>
                  <span class="value_wrapper">
                    您的评分：
                    <span style="font-weight: bold; font-size: 14px; color: #a90000;">{{deliverycredit}}</span>分
                  </span>
                </h2>
                <h2>
                  <b>评分：</b>
                  <RadioGroup
                    v-model="grade"
                    class="label"
                  >
                    <Radio label="好评"></Radio>
                    <Radio label="中评"></Radio>
                    <Radio label="差评"></Radio>
                  </RadioGroup>
                </h2>
                <h2>为该商品评论</h2>
                <textarea
                  name="content"
                  class="ivu-input"
                  placeholder="请在此处输入您的评论"
                  v-model="content"
                  style="margin-bottom: 15px"
                  maxlength="200"
                ></textarea>
                <!--   :max-size="200" -->
                <Upload
                  ref="upload"
                  :before-upload="handleBeforeUpload"
                  :format="['jpg','jpeg','png','gif']"
                  :on-format-error="handleFormatError"
                  :data="uploadData"
                  :headers='{"Auth-Token": upHeaders}'
                  :on-exceeded-size="handleMaxSize"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :action="UploadUrl()"
                >
                  <Button
                    type="ghost"
                    icon="ios-cloud-upload-outline"
                  >选择文件</Button>
                </Upload>
                <p>[文件小于5M，支持jpg、png、gif]</p>
                <input
                  class="regis_ent"
                  type="button"
                  value="发表评论"
                  id="discussBtn"
                  v-on:click="addComment('1')"
                >
              </div>
              <!-- <div class="di_right">
                        <h2>评论规则</h2>
                        <ul>
                            <li>1、成功订购本商品的会员即可发表对该商品的评论</li>
                            <li>2、本商品的首次评论可额外获得50个积分</li>
                            <li>3、针对本商品成功发表文字评论可获得10个积分</li>
                            <li>4、针对本商品成功发表图片评论可获得30个积分。</li>
                        </ul>
                    </div> -->
            </div>
          </form>
        </div>
      </div>
      <!-- 销售记录 -->
      <!--      <div v-show="currTab === 2" class="goods-traded">-->
      <!--        <div v-if="sale.total === 0 ||(sale.list && sale.list.length === 0)" class="not-data">-->
      <!--          <div>暂无购买记录。</div>-->
      <!--        </div>-->
      <!--        <div v-else>-->
      <!--          <Table stripe :columns="columns" :data="sale.list"></Table>-->
      <!--          <paging-->
      <!--            :getList="getSaleList"-->
      <!--            :total="sale.total"-->
      <!--            :pages="sale.pages"-->
      <!--            :no.sync="page.no2">-->
      <!--          </paging>-->
      <!--        </div>-->
      <!--      </div>-->
      <!-- 商品咨询 -->
      <div
        v-show="currTab === 2"
        class="guest-book"
      >
        <div
          v-if="consult.total === 0"
          class="not-data"
        >
          <div>暂无评论，抢沙发，赢取更多积分。</div>
          <div>共0条记录</div>
        </div>
        <div v-else>
          <div class="list">
            <ul>
              <li
                v-for="(item,index) of consult.list"
                :key="index"
              >
                <div class="pic">
                  <img
                    :src="item.face"
                    v-if="item.face"
                  >
                  <img
                    v-else
                    src="//static.kxymall.com/placeholder/no_picture.jpg"
                  />
                  <span>{{item.uname}}</span>
                  <span>{{item.levelname}}</span>
                </div>
                <div class="problem_right">
                  <div class="problem_time">
                    <span>{{chagneTime(item.replytime)}}</span>
                  </div>
                  <p>{{item.content}}</p>
                  <div
                    class="problem_answer"
                    v-if="item.reply"
                  >
                    <div class="pa_top"></div>
                    <div class="ps_bottom">
                      <h3>开心云商客服：</h3>
                      <p>{{item.reply}}</p>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </li>
            </ul>
          </div>
          <paging
            :getList="getCommentList"
            :total="consult.total"
            :pages="consult.pages"
            :no.sync="page.no3"
          >
          </paging>
        </div>
        <div
          class="ask_issue"
          v-if="isLogin"
        >
          <div>
            <h2>请输入您的问题</h2>
            <textarea
              class="shopzx"
              v-model="askInfo"
            ></textarea>
            <div class="ask_btn">
              <a
                class="blue_btn"
                @click="submitAsk"
              >提交咨询</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import paging from "@/views/goods-godule/module-paging";
import {
  getCommentList,
  getSaleList,
  addComment,
  getGoodsCommentInfo,
} from "@/api/goods";
import { parseTime, getNowFormatDate, getSession } from "utils/tool";
import { encryptDes } from "utils/des";
export default {
  name: "detail",
  components: {
    paging,
  },
  props: {
    goodsId: [Number], // 商品id
    storeId: [Number], // 店铺id
    goodsIntros: "", // 详情内容
    goodsVideo: "", // 商品视频地址
  },
  filters: {
    filter_name(value) {
      if (value) {
        return value.charAt(0) + "****" + value.charAt(value.length - 1);
      } else {
        return "用户";
      }
    },
  },
  created() {
    // 获取销售记录
    this.getSaleList();
    this.getUpHeaders();
    this.isLogin = localStorage.getItem("sid") ? true : false;
    //请求判断商品能否评价
    if (this.$route.query.comment && this.isLogin) {
      getGoodsCommentInfo({ goodsId: this.$route.query.goods_id }).then(
        (res) => {
          if (res.resCode === 1) {
            this.commentFalg = true;
            this.currTab = 1;
            getCommentList({
              type: 1,
              goodsId: this.$route.query.goods_id,
              pageNo: 1,
              pageSize: this.page.size,
              grade: "",
            }).then((res) => {
              if (this.type === 1) {
                this.comment = res.data;
                setTimeout(() => {
                  window.scrollTo(0, document.body.scrollHeight);
                }, 500);
              } else {
                this.consult = res.data;
              }
            });
          } else {
            this.commentFalg = false;
          }
        }
      );
    } else {
      this.currTab = 0;
    }
  },
  watch: {
    // 监听商品id变化，页面商品切换时重新请求相关数据
    goodsId() {
      this.type = 0;
      // this.getSaleList();
    },
  },
  data() {
    return {
      tab: ["商品详情", "商品评论", "商品咨询"],
      currTab: 0,
      page: {
        no1: 1,
        no2: 1,
        no3: 1,
        size: 10,
      },
      askInfo: "", // 咨询问题
      sale: [], // 销售记录
      comment: {}, // 评论
      consult: {}, // 咨询
      type: 1, // 1是评论，2是销售记录，3是咨询
      columns: [
        {
          title: "买家",
          align: "center",
          key: "uname",
        },
        {
          title: "数量",
          align: "center",
          key: "goods_num",
        },
        {
          title: "付款日期",
          align: "center",
          key: "rog_time",
        },
      ],
      desccredit: 5,
      servicecredit: 5,
      deliverycredit: 5,
      grade: "好评",
      content: "",
      imgPath: "",
      file: null,
      loadingStatus: false,
      uploadData: { sid: this.$store.getters.sid },
      commentFalg: false,
      token: "",
      upHeaders: "",
      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
    };
  },
  methods: {
    /**
     * [getCommentList 获取评论咨询数据]
     * @param  {[type]} type [1为评论，2为咨询]
     * @return {[type]}      [description]
     */
    addComment(type) {
      if (!this.content) {
        this.$Message.error("请输入商品评论");
        return;
      }
      let _params = {
        goodsId: this.goodsId,
        type: type,
        content: this.content,
        imagePath: this.imgPath,
        orderId: Number(this.$route.query.orderid),
        storeId: this.storeId,
        storeDeliverycredit: this.deliverycredit,
        storeDescribeCredit: this.desccredit,
        storeServicecredit: this.servicecredit,
        grade: "",
      };
      switch (this.grade) {
        case "好评":
          _params.grade = 3;
          break;
        case "中评":
          _params.grade = 2;
          break;
        case "差评":
          _params.grade = 1;
          break;
      }
      let self = this;
      var lock = false;
      layer.confirm(
        "是否确定评论?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            lock = true; //锁定
            addComment(_params).then((res) => {
              if (res.resCode === 1) {
                layer.msg(res.resDesc, { icon: 1 });
                //self.getCommentList();
                scrollTo(0, 0);
                self.$refs.upload.fileList = null;
                self.content = null;
                self.commentFalg = false;
                self.currTab = 0;
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
    // 提交问题咨询 高春超
    submitAsk() {
      if (!this.askInfo) {
        this.$Message.destroy();
        this.$Message.error({
          content: "请输入您的咨询内容",
          top: 50,
        });
      } else {
        let _params = {
          goodsId: this.goodsId,
          storeId: this.storeId,
          orderId: Number(this.$route.query.orderid),
          type: 2,
          content: this.askInfo,
        };
        addComment(_params).then((res) => {
          if (res.resCode === 1) {
            this.$Modal.success({
              content: res.resDesc,
              onOk: () => {
                this.$router.go(0);
              },
            });
          } else {
            this.$Message.error(res.resDesc);
          }
        });
      }
    },
    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/common/upload";
      return actionPath;
    },
    handleSuccess(res) {
      if (res.resCode == 1) {
        this.$Message.success("上传成功");
        // this.imgPath = res.data.imgPath;
        this.imgPath = res.data.fileDetailUrl;
      } else {
        this.$refs.upload.fileList = null;
        this.$Message.error("上传失败");
      }
    },
    handleError() {
      this.$Message.error("上传失败");
    },
    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg和gif.",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "文件太大,不能超过 200k.",
      });
    },
    handleBeforeUpload(file) {
      console.log(this.$refs.upload.fileList);
      const check = this.$refs.upload.fileList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: "只能上传一张评论图片.",
        });
      }
      return check;
    },
    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },
    // 获取商品评论或咨询，1是评论，2是咨询
    getCommentList() {
      let no = this.type === 1 ? this.page.no1 : this.page.no3;
      let reqType = this.type === 1 ? 1 : 2;
      getCommentList({
        type: reqType,
        goodsId: this.goodsId,
        pageNo: no,
        pageSize: this.page.size,
        grade: "",
      }).then((res) => {
        if (res.resCode === 1) {
          if (this.type === 1) this.comment = res.data;
          else this.consult = res.data;
        }
      });
    },
    //瞄点
    jump() {
      var obj = document.getElementById("discuss_form_wrapper");
      var oPos = obj.offsetTop;
      window.scrollTo(0, document.body.scrollHeight);
    },
    // 修改时间格式
    chagneTime(time) {
      return parseTime(time, "{y}-{m}-{d} {h}:{i}");
    },
    // 销售记录
    getSaleList() {
      if (!this.goodsId) return; // 如果商品ID为空则不请求销售记录
      getSaleList({
        goodsId: this.goodsId,
        pageNo: this.page.no2,
        pageSize: this.page.size * 2,
      }).then((res) => {
        if (res.resCode === 1) {
          this.sale = res.data;
        }
      });
    },
    // 点击商品详情tab
    cTab(index) {
      this.currTab = index;
      this.type = index;
      // 判断相关数据是否存在，不用重新请求
      if (index === 1 || index === 2) {
        // 只有切换到商品评论和商品咨询的时候才调用
        if (!this.comment.total || !this.consult.total) {
          this.getCommentList(index);
        }
      }

      if (!this.sale.total) this.getSaleList();
    },
    /**
     * [addZero 格式化数字为两位]
     * @param {[Number]} number [要格式化的数字]
     */
    addZero(number) {
      return number < 10 ? "0" + number : number;
    },
    /**
     * [UnixToDate 秒转换为年月日时分秒的形式]
     * @param {[Number]}  unixTime [秒数]
     * @param {Number} diff   [不同的表现形式]
     * @return {[string]} [格式化后的字符串]
     */
    unixToDate(unixTime, diff) {
      let timeZone = 8; // timeZone 时区
      unixTime = parseInt(unixTime) + parseInt(timeZone) * 60 * 60;
      let time, ymdhms, year, month, date, day, hours, minutes;
      time = new Date(unixTime * 1000);
      ymdhms = "";
      year = time.getUTCFullYear();
      month = time.getUTCMonth() + 1;
      date = time.getUTCDate();
      day = time.getUTCDay();
      hours = this.addZero(time.getUTCHours());
      minutes = this.addZero(time.getUTCMinutes());
      // seconds = addZero(time.getUTCSeconds())
      switch (diff) {
        case 1:
          ymdhms =
            year +
            "-" +
            month +
            "-" +
            date +
            "-" +
            hours +
            "-" +
            minutes +
            "-" +
            day;
          break;
        case 2:
          ymdhms =
            year + "-" + month + "-" + date + "  " + hours + ":" + minutes;
          break;
        case 3:
          ymdhms = year + "/" + month + "/" + date;
          break;
        case 4:
          ymdhms = year.toString() + month.toString() + date.toString();
          break;
        default:
          ymdhms = year + "-" + month + "-" + date;
      }
      return ymdhms;
    },
    //将图片字符串转数组
    toArr(str) {
      if (str) {
        var _str = str.split(",");
        return _str;
      }
    },
  },
};
</script>
<style scoped lang="less">
.sidebar {
  width: 210px;
  display: block;
  float: left;
  height: 500px;

  .search {
    margin: 10px 0px;
    border: 1px solid #ddd;

    .title {
      background-color: #f7f7f7;
      height: 20px;
      padding: 5px 10px;
      border-bottom: solid #ddd;
    }
  }
}
.main {
  float: right;
  width: 980px;

  .tab {
    height: 35px;
    border: 1px solid #d8d8d8;
    background-color: white;

    span {
      float: left;
      font-size: 14px;
      color: #777;
      background: #f5f5f5;
      line-height: 24px;
      border: solid #d8d8d8;
      border-width: 0px 1px 0 0;
      padding: 6px 24px 5px;
      text-decoration: none;
    }

    .active {
      border-top: solid 2px #ff6600;
      padding: 6px 24px;
      margin: -2px 0 -1px;
      background-color: #fff;
      color: #000;
    }
  }
  .content-box {
    background-color: #fff;
    border: solid #e7e7e7;
    border-width: 0 1px 1px 1px;
    padding: 0 0 10px 0;
    overflow: hidden;
    margin-bottom: 20px;
    display: block;

    .goods-detail {
      .video {
        margin: 20px;
        text-align: center;
        background: #000;
        display: inline-block;

        video {
          width: 790px;
          height: 480px;
        }
      }
      .default {
        width: 940px;
        padding: 20px;
        line-height: 24px;
        font-size: 12px;
        color: #333;
        overflow: hidden;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .comment,
    .guest-book {
      .grade {
        height: 64px;
        line-height: 64px;
        border-bottom: 1px solid #c8c8c8;
        overflow: hidden;
        clear: both;

        span {
          display: inline;
          float: left;
          line-height: 64px;
          height: 64px;
        }

        span:first-child {
          margin-right: 49px;
          font-weight: normal;
          padding-left: 23px;
          font-size: 19px;
          color: #656565;
        }

        span:last-child {
          i {
            margin-top: 20px;
            display: block;
            width: 22px;
            height: 22px;
            background: url(//static.kxymall.com/images/wjxpl.jpg) no-repeat
              left top;
            float: left;
          }
        }
      }
      .list ul {
        clear: both;
        overflow: hidden;
        padding: 20px;

        li {
          margin-bottom: 45px;
          clear: both;
          overflow: hidden;

          .pic {
            overflow: hidden;
            width: 80px;
            height: 130px;
            float: left;
            display: inline;
            background-color: #eee;

            img {
              width: 80px;
              height: 83px;
            }

            span {
              display: block;
              height: 23px;
              line-height: 23px;
              text-align: center;
              color: #77939f;
            }
          }
          .right {
            padding-bottom: 25px;
            float: right;
            background-color: #f9f9f9;
            width: 835px;
            position: relative;

            > div:first-child {
              width: 700px;
              margin-left: 25px;
              color: #000;
              line-height: 30px;
            }

            > div:nth-child(2) {
              position: absolute;
              right: 10px;
              top: 0;
              text-align: right;

              span {
                display: block;
              }

              span:first-child {
                line-height: 30px;
                color: #000;
              }
            }
            > div.suolue img,
            div.suolue video {
              margin: 10px 0 0 25px;
              float: left;
            }

            .top {
              width: 561px;
              height: 11px;
              margin: 0;
              margin-left: 23px;
              background: url(//static.kxymall.com/images/background-24.png)
                no-repeat -218px -59px;
            }

            .reply {
              overflow: hidden;
              margin-left: 25px;
              padding-left: 64px;
              width: 636px;
              background: url(//static.kxymall.com/images/background-24.png)
                no-repeat -200px 0px;
              background-color: #fff;

              h3 {
                width: 497px;
                height: 30px;
                line-height: 30px;
                font-weight: normal;
                color: #7095a5;
              }

              p {
                margin: 0px;
                width: 633px;
                text-align: justify;
              }
            }
          }
        }
      }
      .not-data {
        div:first-child {
          clear: both;
          overflow: hidden;
          padding: 20px;
        }

        div:last-child {
          margin: 20px;
          width: 82px;
          height: 32px;
          border: 1px solid #e6e6e6;
          font: 14px/20px "microsoft yahei";
          line-height: 32px;
          text-align: center;
        }
      }
    }
    .goods-traded {
      .paging {
        float: right;
        right: 24px;
      }

      .not-data {
        height: 60px;
        line-height: 60px;
        border-bottom: 1px dashed #e7e7e7;
        text-align: center;
      }
    }
  }
  .ivu-table-wrapper {
    border: none;
  }
}

.ask_issue {
  height: 210px;
  background-color: #f9f9f9;
  margin: 20px;
  padding: 0 20px;
}

.ask_issue h2 {
  color: #222;
  font-size: 14px;
  width: 407px;
  height: 40px;
  line-height: 40px;
  font-weight: normal;
}

.ask_issue textarea {
  width: 722px;
  height: 101px;
  line-height: 20px;
  font-size: 12px;
}

.ask_issue p {
  width: 407px;
  line-height: 35px;
  color: #222;
  overflow: hidden;
  white-space: nowrap;
}

.ask_btn {
  float: none;
  display: block;
  text-align: left;
  margin: 10px 0;
}

.blue_btn {
  padding: 0;
  margin: 0;
  height: 36px;
  line-height: 36px;
  width: 120px;
  border: medium none;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  background-color: #d93600;
  color: #fff;
  outline: medium none;
  display: inline-block;
  font-size: 14px;
  border-radius: 4px;
  -moz-user-select: none;
}

/**********************
   商品详情评论
   ********************/
.discuss_issue {
  margin: 20px;
  height: auto;
  background-color: #f5f5f5;
  padding: 20px;
  overflow: hidden;
}

.discuss_issue .di_left {
  width: 407px;
  height: auto;
  float: left;
  display: inline;
  padding-left: 21px;
}

.discuss_issue .di_left h2 {
  color: #222;
  font-size: 14px;
  width: 407px;
  height: 36px;
  line-height: 40px;
  font-weight: normal;
  float: left;
}

.discuss_issue .di_left h2 b {
  float: left;
  display: inline;
  font-weight: normal;
}

.discuss_issue .di_left h2 span {
  font-size: 12px;
  display: inline;
}

.discuss_issue .di_left h2 .grade {
  margin-right: 20px;
  float: left;
}

.discuss_issue .di_left textarea {
  width: 372px;
  height: 101px;
  line-height: 20px;
  font-size: 12px;
}

.discuss_issue .di_left p {
  width: 407px;
  line-height: 35px;
  color: #222;
  overflow: hidden;
  white-space: nowrap;
}

.discuss_issue .di_right {
  width: 324px;
  height: 300px;
  float: left;
  display: inline;
  overflow: hidden;
}

.discuss_issue .di_right h2 {
  width: 324px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #222;
  font-size: 14px;
  font-weight: normal;
}

.discuss_issue .di_right ul {
  width: 301px;
  height: 245px;
  overflow: hidden;
}

.discuss_issue .di_right ul li {
  width: 301px;
  line-height: 35px;
  color: #222;
  height: 35px;
}

#discuss_form_wrapper .grade ul li {
  width: 16px;
  height: 16px;
  display: block;
  float: left;
  overflow: hidden;
}

#discuss_form_wrapper .grade ul li a {
  display: block;
  width: 16px;
  height: 16px;
  background: url("//static.kxymall.com/images/background-24.png") no-repeat
    scroll -16px -135px transparent;
  text-indent: -9999px;
  overflow: hidden;
}

#discuss_form_wrapper .grade a.selected {
  background-position: 0 -135px;
}

#gradevalue {
  width: 16px;
  line-height: 16px;
  text-align: right;
  padding: 0;
}

#grade_input {
  padding: 2px;
  width: 20px;
}

#discuss_form_wrapper .grade {
  height: 26px;
  line-height: 26px;
  float: left;
  margin-top: 5px;
  clear: none;
  border-bottom: 0px;
}

#discuss_form_wrapper .value_wrapper {
  display: block;
  float: left;
  margin-left: 15px;
}

#discuss_list_wrapper .problem_time {
  top: 0;
  text-align: right;
}

#discuss_list_wrapper .page {
  margin: 10px;
}

.regis_ent {
  padding: 0px;
  margin: 0px;
  height: 36px;
  line-height: 36px;
  width: 120px;
  border: medium none;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  font-family: 微软雅黑, 宋体;
  background-color: #d93600;
  color: #fff;
  outline: medium none;
  display: inline-block;
  font-size: 14px;
  border-radius: 4px;
  -moz-user-select: none;
}

.regis_ent:hover {
  text-decoration: none !important;
  background-color: #ff4400;
  color: #fff;
}

.problem_right {
  padding-bottom: 25px;
  float: right;
  background-color: #f9f9f9;
  width: 835px;
  position: relative;
}

.problem_time {
  position: absolute;
  right: 10px;
  top: 5px;
}

.problem_right p {
  width: 700px;
  margin-left: 25px;
  color: #000;
  line-height: 30px;
}

.problem_answer {
  margin-left: 25px;
  clear: both;
  width: 561px;
}

.problem_answer .pa_top {
  width: 561px;
  height: 11px;
  margin: 0;
  background: url(//static.kxymall.com/images/background-24.png) no-repeat -218px -59px;
}

.problem_answer .ps_bottom {
  overflow: hidden;
  padding-left: 64px;
  width: 636px;
  background: url(//static.kxymall.com/images/background-24.png) no-repeat -200px
    0px;
  background-color: #fff;
}

.problem_answer .ps_bottom h3 {
  width: 497px;
  height: 30px;
  line-height: 30px;
  font-weight: normal;
  color: #7095a5;
}

.ps_bottom p {
  margin: 0px;
  width: 633px;
  text-align: justify;
}
.shoppl {
  margin-top: 15px;
  font-size: 14px;
  display: block;
  float: right;
  color: #fff;
  width: 120px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}
.shopzx {
  resize: none;
  border: 1px solid #d8d8d8;
  padding-left: 4px;
}
</style>



// WEBPACK FOOTER //
// module-detail-content.vue?87a64f14